module.exports = __webpack_public_path__ + "media/error.7195ed31.wav";